import CitySEOHead from "@/components/feature/CitySEOHead";
import FortMyersHeroSection from "./components/HeroSection";
import FortMyersStickyNav from "./components/StickyNav";
import FortMyersProcessingTimeSection from "./components/ProcessingTimeSection";
import FortMyersServicesSection from "./components/ServicesSection";
import FortMyersLocalAreaSection, { landmarks } from "./components/LocalAreaSection";
import FortMyersTravelTimingSection from "./components/TravelTimingSection";
import FortMyersDestinationsSection from "./components/DestinationsSection";
import FortMyersTestimonialsSection from "./components/TestimonialsSection";
import FortMyersAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import FortMyersComparisonSection from "./components/ComparisonSection";
import FortMyersMistakesSection from "./components/MistakesSection";
import FortMyersHowItWorksSection from "./components/HowItWorksSection";
import FortMyersFAQSection, { faqs } from "./components/FAQSection";
import FortMyersHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import FortMyersFinalCTA from "./components/FinalCTA";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";

const pageTitle = "Emergency Passport Fort Myers, FL — Expedited & Fast Passport Service | Fast Passport Center";
const pageDescription = "Emergency and expedited passport services in Fort Myers, FL — as fast as 2–3 business days. A+ BBB rated, registered State Dept. courier serving Lee County, Cape Coral, Sanibel, and Southwest Florida travelers needing urgent passport help.";

const areaServedList = [
  { "@type": "City", name: "Fort Myers" },
  { "@type": "City", name: "Cape Coral" },
  { "@type": "City", name: "Estero" },
  { "@type": "City", name: "North Fort Myers" },
  { "@type": "City", name: "Lehigh Acres" },
  { "@type": "City", name: "Fort Myers Beach" },
  { "@type": "City", name: "Sanibel" },
  { "@type": "City", name: "Bonita Springs" },
  { "@type": "AdministrativeArea", name: "Lee County" },
];

const serviceAreaDesc = "Fast Passport Center is a registered U.S. Department of State passport courier serving Fort Myers, Cape Coral, Estero, and Lee County with expedited passport processing as fast as 24 hours. A+ BBB rated.";

const servicesSchema = [
  { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
  { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
  { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
  { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
  { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
  { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  { name: "Second Passport & Damaged", description: "Second passport issuance for frequent travelers and damaged passport replacement." },
];

export default function FortMyersPage() {
  return (
    <>
      <CitySEOHead
        city="Fort Myers"
        state="Florida"
        stateAbbr="FL"
        route="/cities/fort-myers"
        title={pageTitle}
        description={pageDescription}
        ogTitle={pageTitle}
        ogDescription={pageDescription}
        twitterTitle={pageTitle}
        twitterDescription={pageDescription}
        geoPlacename="Fort Myers, Florida"
        geoPosition="26.6406;-81.8723"
        keywords="expedited passport Fort Myers, emergency passport Fort Myers FL, same day passport Fort Myers, fast passport Florida, passport renewal Fort Myers, Lee County passport courier"
        faqs={faqs}
        servicesSchema={servicesSchema}
        statePageName="Florida"
        statePageRoute="/states/florida"
        lastModified="2026-06-09"
        areaServedList={areaServedList}
        serviceAreaDesc={serviceAreaDesc}
        landmarks={landmarks}
      />
      <div className="font-sans">
        <FortMyersHeroSection />
        <FortMyersStickyNav />
        <FortMyersProcessingTimeSection />
        <FortMyersLocalAreaSection />
        <FortMyersServicesSection />
        <FortMyersTravelTimingSection />
        <FortMyersDestinationsSection />
        <FortMyersTestimonialsSection />
        <FortMyersAcceptanceFacilitiesSection />
        <FortMyersComparisonSection />
        <FortMyersMistakesSection />
        <FortMyersHowItWorksSection />
        <FortMyersFAQSection />
        <FortMyersHelpfulResourcesSection />
        <SEOCrossLinks currentRoute="/cities/fort-myers" state="FL" />
        <FortMyersFinalCTA />
      </div>
    </>
  );
}